import React from 'react';
import { withRouter } from "react-router-dom";
import { Typography } from "../ecosystem";

const ResourceSubDescription = ({
    description,
    disabled
}) => {

    return (<div className="resource-sub-description-container">
        <Typography
            type="body-02"
            color={disabled ? "$color-secondary-a3" : undefined }
        >
            {description}
        </Typography>
    </div>);
}

export default withRouter(ResourceSubDescription);
